import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/tailwind.css';

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

/*
console.log('🔧 Environment:', {
  NODE_ENV: process.env.NODE_ENV,
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
  USE_MOCK: process.env.VUE_APP_USE_MOCK,
  HAS_API_KEY: !!process.env.VUE_APP_API_KEY
});
*/